import { defineStore } from 'pinia'
import api from '@/utils/api'

export const useAppStore = defineStore('app', {
  state: () => ({
    status: null,
    loading: false,
    error: null,
    logs: [],
    syncInterval: null,
    autoRefresh: true
  }),

  getters: {
    systemHealth: (state) => {
      if (!state.status) return 'unknown'
      
      const config = state.status.config_status
      const hasRequiredConfig = config.mirakl_url && config.mirakl_api_key && 
                               config.billbee_url && config.billbee_api_key

      if (!hasRequiredConfig) return 'error'
      
      const stats = state.status.statistics
      const hasErrors = state.status.recent_errors && state.status.recent_errors.length > 0
      
      if (hasErrors) return 'warning'
      if (stats && stats.total_active > 0) return 'active'
      
      return 'ok'
    },

    syncStatus: (state) => {
      if (!state.status) return 'unknown'
      
      const lastRun = state.status.last_run
      const now = new Date()
      
      let status = 'ok'
      
      // Check if any task is overdue (> 2x interval)
      if (lastRun.fetch_orders) {
        const lastFetch = new Date(lastRun.fetch_orders)
        const overdue = (now - lastFetch) > (30 * 60 * 1000 * 2) // 2x 30 min
        if (overdue) status = 'warning'
      }
      
      return status
    }
  },

  actions: {
    async fetchStatus() {
      this.loading = true
      this.error = null
      
      try {
        const response = await api.get('/api/endpoints/status.php')
        
        if (response.data.success) {
          this.status = response.data.data
        } else {
          throw new Error(response.data.error || 'Failed to fetch status')
        }
      } catch (error) {
        this.error = error.message
        console.error('Error fetching status:', error)
      } finally {
        this.loading = false
      }
    },

    async fetchLogs(type = 'all', lines = 100) {
      try {
        const response = await api.get('/api/endpoints/logs.php', {
          params: { type, lines }
        })
        
        if (response.data.success) {
          this.logs = response.data.data
        } else {
          throw new Error(response.data.error || 'Failed to fetch logs')
        }
      } catch (error) {
        this.error = error.message
        console.error('Error fetching logs:', error)
      }
    },

    startAutoRefresh() {
      if (this.syncInterval) return
      
      this.autoRefresh = true
      this.syncInterval = setInterval(() => {
        this.fetchStatus()
      }, 30000) // 30 seconds
    },

    stopAutoRefresh() {
      if (this.syncInterval) {
        clearInterval(this.syncInterval)
        this.syncInterval = null
      }
      this.autoRefresh = false
    },

    toggleAutoRefresh() {
      if (this.autoRefresh) {
        this.stopAutoRefresh()
      } else {
        this.startAutoRefresh()
      }
    }
  }
})